import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReceivedCouponListItem from './ReceivedCouponListItem';

export default class ReceivedCouponList extends Component {
  render () {
    const { couponInfos, type, showDDay, showUsed, showOutdated } = this.props;
    return (
      <ul className="list_coupon">
        {couponInfos.map((couponInfo, idx) =>
          <ReceivedCouponListItem key={idx} couponInfo={couponInfo} type={type}
            showDDay={showDDay} showUsed={showUsed} showOutdated={showOutdated} />
        )}
      </ul>
    );
  }
}

ReceivedCouponList.propTypes = {
  showDDay: PropTypes.bool.isRequired,
  showUsed: PropTypes.bool.isRequired,
  showOutdated: PropTypes.bool.isRequired
};

ReceivedCouponList.defaultProps = {
  showDDay: false,
  showUsed: false,
  showOutdated: false
};



// WEBPACK FOOTER //
// ./src/components/ReceivedCouponList/index.js